import React, { useState } from 'react';
import axios from 'axios';
import Modal from './Modal';
import { ShieldCheck } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { customerToken } from '../sections/SiteChrome';

const MONTHS = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
const YEARS = [];
for (let y = 1405; y >= 1300; y--) YEARS.push(y);

const inStyle = { width: '100%', padding: '11px 14px', borderRadius: 12, border: '1.5px solid #E4E4E7', fontFamily: 'inherit', background: '#fff', outline: 'none', marginBottom: 10, boxSizing: 'border-box', fontSize: '0.88rem' };

/**
 * Identity verification modal (national code + Jalali birth date).
 * Shown before checkout / manual receipt when admin made KYC mandatory
 * (site_settings.kyc.profile_required). Saves via POST /auth/profile.
 * Props: open, onClose, onVerified(user), note (why it's needed).
 */
export default function IdentityModal({ open, onClose, onVerified, note, inline }) {
  const [nationalCode, setNationalCode] = useState('');
  const [by, setBy] = useState('1370');
  const [bm, setBm] = useState('5');
  const [bd, setBd] = useState('12');
  const [busy, setBusy] = useState(false);
  const toastOpts = { position: 'bottom-right', autoClose: 5000, theme: 'colored' };

  const submit = async () => {
    if (!/^\d{10}$/.test(nationalCode)) { toast.warn('کد ملی باید ۱۰ رقم باشد.', toastOpts); return; }
    const birth = `${by}/${String(bm).padStart(2, '0')}/${String(bd).padStart(2, '0')}`;
    setBusy(true);
    try {
      const r = await axios.post('/auth/profile',
        { national_code: nationalCode, birth_date: birth },
        { headers: { Authorization: `Bearer ${customerToken()}` } });
      setNationalCode('');
      if (onVerified) onVerified(r.data.user);
    } catch (e) {
      toast.error(e.response?.data?.message || 'خطا در ثبت مشخصات.', toastOpts);
    }
    setBusy(false);
  };

  if (!open) return null;
  const body = (
    <>
      <div style={{ background: '#FFFBEB', border: '1.5px solid #FDE68A', borderRadius: 12, padding: '10px 14px', fontSize: '0.82rem', color: '#92400E', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
        <ShieldCheck size={16} style={{ flexShrink: 0 }} /> {note || 'برای ادامه، ابتدا مشخصات هویتی خود را تکمیل کنید.'}
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} rtl theme="colored" style={{ zIndex: 99999 }} />
      <label style={{ display: 'block', fontSize: '0.78rem', color: '#78716c', marginBottom: 4 }}>کد ملی</label>
      <input value={nationalCode} onChange={e => setNationalCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}
        placeholder="کد ملی ۱۰ رقمی" style={{ ...inStyle, textAlign: 'center' }} dir="ltr" inputMode="numeric" />
      <label style={{ display: 'block', fontSize: '0.78rem', color: '#78716c', marginBottom: 4 }}>تاریخ تولد (شمسی)</label>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 12 }}>
        <select value={bd} onChange={e => setBd(e.target.value)} style={{ ...inStyle, marginBottom: 0 }}>
          {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
        </select>
        <select value={bm} onChange={e => setBm(e.target.value)} style={{ ...inStyle, marginBottom: 0 }}>
          {MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
        </select>
        <select value={by} onChange={e => setBy(e.target.value)} style={{ ...inStyle, marginBottom: 0 }}>
          {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <button onClick={submit} disabled={busy}
        style={{ width: '100%', padding: '12px', borderRadius: 12, border: 'none', background: '#18181B', color: '#fff', fontFamily: 'inherit', fontSize: '0.88rem', fontWeight: 800, cursor: 'pointer', opacity: busy ? 0.6 : 1 }}>
        {busy ? 'در حال ثبت...' : 'تایید و ادامه'}
      </button>
    </>
  );
  if (inline) return <div style={{ marginTop: 12 }}>{body}</div>;
  return (
    <Modal open={open} onClose={onClose} title="احراز هویت">
      {body}
    </Modal>
  );
}
